<template>
  <nav class="footer-legal" :aria-label="STRINGS.aria.labels.legalNavigation">
    <button
      class="footer-legal-link"
      @click="emit('navigate', 'about')"
      data-testid="footer-about-link"
    >
      {{ STRINGS.legal.footer.about }}
    </button>
    <span class="footer-legal-sep" aria-hidden="true">&bull;</span>
    <button
      class="footer-legal-link"
      @click="emit('navigate', 'privacy')"
      data-testid="footer-privacy-link"
    >
      {{ STRINGS.legal.footer.privacy }}
    </button>
    <span class="footer-legal-sep" aria-hidden="true">&bull;</span>
    <button
      class="footer-legal-link"
      @click="emit('navigate', 'terms')"
      data-testid="footer-terms-link"
    >
      {{ STRINGS.legal.footer.terms }}
    </button>
  </nav>
</template>

<script setup lang="ts">
import type { NavigationState } from '@/types/websocket';
import STRINGS from '@/constants/strings';

const emit = defineEmits<{
  navigate: [target: NavigationState];
}>();
</script>

<style scoped>
.footer-legal {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding-top: 2rem;
  margin-top: auto;
}

.footer-legal-link {
  font-family: var(--font-sans);
  font-size: 0.6875rem;
  color: var(--color-arena-text-muted);
  background: transparent;
  border: none;
  cursor: pointer;
  letter-spacing: 0.04em;
  transition: color 150ms ease;
  padding: 0;
}

.footer-legal-link:hover {
  color: var(--color-arena-text-muted);
}

.footer-legal-sep {
  color: var(--color-arena-text-dim);
  opacity: 0.4;
  font-size: 0.5rem;
  user-select: none;
}

@media (min-width: 768px) {
  .footer-legal-link {
    font-size: 0.75rem;
  }

  .footer-legal {
    gap: 0.625rem;
  }
}
</style>
